export type UTMParams = Partial<
  Record<
    | "utm_source"
    | "utm_medium"
    | "utm_campaign"
    | "utm_term"
    | "utm_content"
    | "fbclid"
    | "ttclid"
    | "gclid",
    string
  >
>;

const UTM_KEYS: (keyof UTMParams)[] = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "fbclid",
  "ttclid",
  "gclid",
];

export function collectUtmFromLocation(href?: string): UTMParams {
  try {
    const url = new URL(
      href || (typeof window !== "undefined" ? window.location.href : "")
    );
    const p = url.searchParams;
    const out: UTMParams = {};
    for (const k of UTM_KEYS) {
      const v = p.get(k as string);
      if (v) out[k] = v;
    }
    return out;
  } catch {
    return {};
  }
}

export function appendUtmToUrl(url: string, utm?: UTMParams): string {
  if (!utm) return url;
  try {
    const target = new URL(
      url,
      typeof window !== "undefined" ? window.location.origin : undefined
    );
    for (const k of UTM_KEYS) {
      const v = utm[k];
      if (v) target.searchParams.set(k, v);
    }
    return target.toString();
  } catch {
    return url;
  }
}

export function readCookie(name: string): string | undefined {
  if (typeof document === "undefined") return undefined;
  const m = document.cookie.match(new RegExp("(^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[2]) : undefined;
}

export function getPersistedUtm(): UTMParams {
  const out: UTMParams = {};
  for (const k of UTM_KEYS) {
    const v = readCookie(k);
    if (v) out[k] = v;
  }
  return out;
}
